<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="头像" name="headImg">
                        <img-upload v-model:value="form.headImg" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="手机号" name="contactNumber">
                        <a-input style="width:100%" v-model:value="form.contactNumber" placeholder="请输入需求类型" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="顾问名称" name="name">
                        <a-input style="width:100%" v-model:value="form.name" placeholder="请输入需求内容" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="身份证号" name="employeeCard">
                        <a-input style="width:100%" v-model:value="form.employeeCard" placeholder="请输入联系人" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="所在部门名称" name="deptName">
                        <a-input style="width:100%" v-model:value="form.deptName" placeholder="请输入联系电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="职位名称" name="position">
                        <a-input style="width:100%" v-model:value="form.position" placeholder="请输入需求状态" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="电子邮箱" name="email">
                        <a-input style="width:100%" v-model:value="form.email" placeholder="请输入需求状态" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="简介" name="introduce">
                        <a-textarea v-model:value="form.introduce" placeholder="请输入文章摘要"
                            :auto-size="{ minRows: 5, maxRows: 6 }" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeAdvisor} from "@/api/finance";
import {innovation} from "@/config/variableConfig";

export default {
    name: "AddOrEditModal",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            innovation,
            form: {
                id: null,
                headImg: null,
                email: null,
                contactNumber: null,
                name: null,
                employeeCard: null,
                deptName: null,
                position: null,
                introduce: null,

            },
            rules: {
                    id: [],
                    headImg: [],
                    email: [dataCheck.required({})],
                    contactNumber: [dataCheck.required({})],
                    name: [dataCheck.required({})],
                    employeeCard: [dataCheck.required({})],
                    deptName: [dataCheck.required({})],
                    position: [dataCheck.required({})],
                    introduce: [dataCheck.required({})],
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeAdvisor.edit
                } else {
                    return financeAdvisor.add
                }
            },
            postMethod() {
                if (this.form.id) {
                    return 'put'
                } else {
                    return 'post'
                }
            }
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
